/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenWeaknessCountSnapshot } from './OpenWeaknessCountSnapshot';
import {
    OpenWeaknessCountSnapshotFromJSON,
    OpenWeaknessCountSnapshotFromJSONTyped,
    OpenWeaknessCountSnapshotToJSON,
    OpenWeaknessCountSnapshotToJSONTyped,
} from './OpenWeaknessCountSnapshot';

/**
 * 
 * @export
 * @interface WeaknessBlastRadiusAssetDto
 */
export interface WeaknessBlastRadiusAssetDto {
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    imageDigest?: string;
    /**
     * 
     * @type {number}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    openFindingCount?: number;
    /**
     * 
     * @type {OpenWeaknessCountSnapshot}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    severityBreakdown?: OpenWeaknessCountSnapshot;
    /**
     * 
     * @type {number}
     * @memberof WeaknessBlastRadiusAssetDto
     */
    materializedOpenWeaknessCount?: number;
}

/**
 * Check if a given object implements the WeaknessBlastRadiusAssetDto interface.
 */
export function instanceOfWeaknessBlastRadiusAssetDto(value: object): value is WeaknessBlastRadiusAssetDto {
    return true;
}

export function WeaknessBlastRadiusAssetDtoFromJSON(json: any): WeaknessBlastRadiusAssetDto {
    return WeaknessBlastRadiusAssetDtoFromJSONTyped(json, false);
}

export function WeaknessBlastRadiusAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessBlastRadiusAssetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'imageDigest': json['imageDigest'] == null ? undefined : json['imageDigest'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenWeaknessCountSnapshotFromJSON(json['severityBreakdown']),
        'materializedOpenWeaknessCount': json['materializedOpenWeaknessCount'] == null ? undefined : json['materializedOpenWeaknessCount'],
    };
}

export function WeaknessBlastRadiusAssetDtoToJSON(json: any): WeaknessBlastRadiusAssetDto {
    return WeaknessBlastRadiusAssetDtoToJSONTyped(json, false);
}

export function WeaknessBlastRadiusAssetDtoToJSONTyped(value?: WeaknessBlastRadiusAssetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'imageDigest': value['imageDigest'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': OpenWeaknessCountSnapshotToJSON(value['severityBreakdown']),
        'materializedOpenWeaknessCount': value['materializedOpenWeaknessCount'],
    };
}

